import { Component } from '@angular/core'
import { AgRendererComponent } from 'ag-grid-angular'
import moment from 'moment'

@Component({
  selector: 'app-date-column-renderer',
  template: ` {{ processDate() }} `,
  standalone: false
})
export class DateColumnRendererComponent implements AgRendererComponent {
  private params: any

  agInit(params: any): void {
    this.params = params
  }

  refresh(params: any): boolean {
    return false
  }

  processDate(): string {
    return moment(this.params.value).format('L')
  }
}
